<template>
    <el-dialog title="编辑会员关系" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
               :close-on-press-escape="false">
        <el-form size="small" :model="form">
            <el-form-item label="用户id" :label-width="formLabelWidth">
                <el-input v-model="form.user_id" autocomplete="off" readonly></el-input>
            </el-form-item>
            <el-form-item label="昵称" :label-width="formLabelWidth">
                <el-input v-model="form.nickName" autocomplete="off" readonly></el-input>
            </el-form-item>
            <el-form-item label="手机号" :label-width="formLabelWidth">
                <el-input v-model="form.mobile" autocomplete="off" readonly></el-input>
            </el-form-item>
            <el-form-item label="绑定推荐人" :label-width="formLabelWidth">
                <div class="d-s-s d-c">
                    <el-button @click="openGetuser"  icon="el-icon-plus">选择会员</el-button>
                    <div class="d-s-s" v-if="form.user">
                        <p class="lh18 ww100 text-ellipsis">用户昵称：{{form.user.nickName}}</p>
                    </div>
                    <div class="d-s-s"  v-if="form.user">
                        <p class="lh18 ww100 text-ellipsis">等级：{{form.user.grade.name}}</p>
                    </div>
                </div>
            </el-form-item>
            
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible">取 消</el-button>
            <el-button type="primary" @click="editUser" :loading="loading">确 定</el-button>
        </div>
        <!--选择用户-->
        <GetUser :is_open="open_getuser" @close="closeGetuserFunc"></GetUser>
    </el-dialog>
</template>

<script>
    import UserApi from '@/api/user.js';
    import GetUser from '@/components/user/GetUser.vue';
    export default {
        components: {
            GetUser
        },
        data() {
            return {
                /*左边长度*/
                formLabelWidth: '120px',
                /*是否显示*/
                loading: false,
                dialogVisible: false,
                open_getuser:false,
            };
        },
        props: ['open_relation','form'],
        created() {
            this.dialogVisible = this.$parent.open_relation;
        },
        methods: {
            openGetuser() {
                this.open_getuser = true;
            },
            /*关闭获取用户*/
            closeGetuserFunc(e) {
                if (e.type != 'error') {
                    this.form.user=e.params[0];
                    this.form.user.user_id=e.params[0].user_id;
                }
                this.open_getuser = false;
            },
            editUser(){
                let self = this;
                self.loading = true;
                let params = self.form;
                params.referee_id = self.form.user.user_id;
                console.log(params,'11111111')
                
                UserApi.relation(params,true)
                    .then(data => {
                        self.loading = false;
                        if (data.code == 1) {
                            self.$message({
                                message: '恭喜你，用户推荐人修改成功',
                                type: 'success'
                            });
                            self.dialogFormVisible(true);
                        }
                    })
                    .catch(error => {
                        self.loading = false;
                    });
            },
            /*关闭弹窗*/
            dialogFormVisible(e) {
                if (e) {
                    this.$emit('closeDialog', {
                        type: 'success',
                        openDialog: false
                    })
                } else {
                    this.$emit('closeDialog', {
                        type: 'error',
                        openDialog: false
                    })
                }
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/user/user/dialog/Relation.vue